import { Link } from 'react-router';

import { PrimaryCTA } from '../../components/PrimaryCTA';
import { SecondaryCTA } from '../../components/SecondaryCTA';
import { SectionWrapper } from '../../components/SectionWrapper';
import { leaderCards } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachLeadersSection.module.css';

export function KaiCoachLeadersSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-leaders-title"
      background="navy"
      className={styles.root}
      data-testid="kai-coach-section-leaders"
    >
      <KaiCoachSectionHead
        id="kai-coach-leaders-title"
        kicker="For academic leaders"
        lead="A response to generative AI that strengthens student writing instead of policing it, measured on real coursework, and built by Kudu at no cost to your institution."
        title={
          <>
            Integrity by design. <em>Evidence of learning.</em>
          </>
        }
        tone="dark"
      />
      <ul className={styles.grid}>
        {leaderCards.map((card, index) => (
          <li className={styles.card} key={card.title}>
            <span aria-hidden="true" className={styles.number}>
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className={styles.cardTitle}>{card.title}</h3>
            <p className={styles.cardBody}>
              {card.body}
              {index === leaderCards.length - 1 ? (
                <>
                  {' '}
                  <Link className={styles.cardLink} to="/ai#how-kai-works">
                    How KAI handles data
                  </Link>
                </>
              ) : null}
            </p>
          </li>
        ))}
      </ul>
      <div className={styles.actions}>
        <PrimaryCTA className={styles.primary} href="/contact" label="Plan a campus pilot" />
        <SecondaryCTA className={styles.secondary} href="#method" label="Read the method note" />
      </div>
    </SectionWrapper>
  );
}
